import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const Header = ({
  toggleSidemenu,
  toggleMobileMenu,
  toggleSearchBox,
  toggleCart,
}) => {
  const location = useLocation();

  // Update isActive to support subroutes
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className="vs-header header-layout1"
      // style={{ position: "fixed", width: "100%", top: "0", right: "0" }}
    >
      <div className="container py-2">
        <div className="header-top">
          <div className="row justify-content-between align-items-center">
            <div className="col d-none d-lg-block">
              <ul className="header-contact">
                <li>
                  <i className="fas fa-envelope"></i>
                  <Link to="mailto:info@citylifevhr.com">
                    info@citylifevhr.com
                  </Link>
                </li>
                <li>
                  <i className="fas fa-phone-alt"></i>
                  <Link to="tel:+971 56 118 4114">+971 56 118 4114</Link>
                </li>
              </ul>
            </div>

            <div className="col-auto d-none d-lg-block">
              <div className="header-social">
                <Link
                  to="https://www.facebook.com/people/City-Life-Vacation-Homes-Rental-LLC-Dubai/61560822997286/"
                  target="_blank"
                >
                  <i className="fab fa-facebook-f"></i>
                </Link>
                <Link to="#" target="_blank">
                  <i className="fab fa-instagram"></i>
                </Link>
                <Link to="#" target="_blank">
                  <i className="fab fa-pinterest-p"></i>
                </Link>
                <Link to="#" target="_blank">
                  <i className="fab fa-twitter"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sticky-wrapper">
        <div className="sticky-active">
          <div className="container position-relative z-index-common">
            <div className="row align-items-center justify-content-between">
              <div className="col-auto">
                <div className="vs-logo">
                  <Link to="/">
                    <img
                      src="/img/logo2.jpg"
                      alt="logo"
                      style={{ height: "100px", width: "150px" }}
                    />
                  </Link>
                </div>
              </div>

              <div className="col text-end">
                <nav className="main-menu menu-style1 d-none d-lg-block">
                  <ul>
                    <li>
                      <NavLink
                        exact="true"
                        to="/"
                        className={` ${isActive("/") ? "link-dom active" : ""}`}
                      >
                        Home
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/about"
                        className={` ${
                          isActive("/about") ? "link-dom active" : ""
                        }`}
                      >
                        About Us
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/properties"
                        className={` ${
                          isActive("/properties") ? "link-dom active" : ""
                        }`}
                      >
                        Properties
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/gallery"
                        className={` ${
                          isActive("/gallery") ? "link-dom active" : ""
                        }`}
                      >
                        Gallery
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/blogs"
                        className={` ${
                          isActive("/blogs") ? "link-dom active" : ""
                        }`}
                      >
                        Blogs
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/contact"
                        className={` ${
                          isActive("/contact") ? "link-dom active" : ""
                        }`}
                      >
                        Contact Us
                      </NavLink>
                    </li>
                  </ul>
                </nav>

                <button
                  className="vs-menu-toggle d-inline-block d-lg-none"
                  onClick={toggleMobileMenu}
                >
                  <i className="fal fa-bars"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
